import { HeroPrimary } from "../headers/HeroPrimary";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionGridColumns } from "../sections/grids/SectionGridColumns";
import { CardThumbnail } from "../components/cards/CardThumbnail";
import { SectionGridFourColumns } from "../sections/grids/SectionGridFourColumns";
import { CardImageTile } from "../components/cards/CardImageTile";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";

type PartnerForLink = {
  link?: string | null;
  slug?: { current?: string };
  _type?: string;
};

type PartnerSection = {
  title?: string;
  text?: unknown;
} | null | undefined;

/** Prefer `link` (external URL); internal partner document routes are not used. */
function partnerExternalLink(partner: PartnerForLink) {
  if (partner?.link) {
    return {
      _type: "link" as const,
      type: "external" as const,
      slug: partner.link,
      newTab: true,
    };
  }
  return undefined;
}

function PartnerArchiveThreeColumns({
  section,
  partners,
}: {
  section: PartnerSection;
  partners: any[];
}) {
  if (!section || !partners.length) {
    return null;
  }
  return (
    <SectionGridColumns

    columns={2}
      title={section.title}
      text={section.text as any}
    >
      {partners.map((partner: any, index: number) => (
        <CardThumbnail
          key={partner._id ?? index}
          card={{
            title: partner.name ?? partner.title,
            text: partner.shortDescription ?? partner.shortText,
            link: partnerExternalLink(partner),
            image: partner.imageThumbnail || partner.image,
          }}
          theme="dark"
        />
      ))}
    </SectionGridColumns>
  );
}


function PartnerArchiveGrid({
  section,
  partners,
}: {
  section: PartnerSection;
  partners: any[];
}) {
  if (!section || !partners.length) {
    return null;
  }
  return (
    <SectionGridFourColumns title={section.title} text={section.text as any}>
      {partners.map((partner: any, index: number) => {
        const ext = partnerExternalLink(partner);
        return (
          <CardImageTile
            key={partner._id ?? index}
            image={partner.image}
            link={
              ext
                ? {
                    slug: ext.slug,
                    _type: "link",
                    type: "external",
                  }
                : undefined
            }
          />
        );
      })}
    </SectionGridFourColumns>
  );
}

export interface ITemplateArchiveIndustryPartners {
  data: any;
}

export default function TemplateArchiveIndustryPartners({
  data,
}: ITemplateArchiveIndustryPartners) {
  const {
    heroPrimary,
    partners,
    partnerArchiveSectionFounding,
    partnerArchiveSectionEstablishing,
    partnerArchiveSectionSupporting,
  } = data;

  const allPartners: any[] = Array.isArray(partners)
    ? partners
    : (partners as { items?: any[] } | undefined)?.items ?? [];

  const foundingPartners = allPartners.filter(
    (p: any) => p?.partnerType === "foundingPartner",
  );
  const establishingPartners = allPartners.filter(
    (p: any) => p?.partnerType === "establishingPartner",
  );
  const supportingPartners = allPartners.filter(
    (p: any) => p?.partnerType === "supportingPartner",
  );

  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}
      <WrapperComponents>
        <PartnerArchiveThreeColumns
          section={partnerArchiveSectionFounding}
          partners={foundingPartners}
        />
        <PartnerArchiveGrid
          section={partnerArchiveSectionEstablishing}
          partners={establishingPartners}
        />
        <PartnerArchiveGrid
          section={partnerArchiveSectionSupporting}
          partners={supportingPartners}
        />
      </WrapperComponents>
    </>
  );
}
